<template>
	<v-container class="admin-register-bg" fluid>
		<v-snackbar v-model="alert.show" top :color="alert.type || 'error'" dark :timeout="alert.timeout || 10000">
			[提示] {{ alert.msg }} ~~
			<v-btn dark flat @click="alert.show = false">关闭</v-btn>
		</v-snackbar>
		<v-layout align-center justify-start column fill-height>
			<v-flex class="top-logo">
				<img v-if="tenant.logo" class="logo" :src="tenant.logo" />
				<img v-else class="logo" src="@/assets/logo-w.png" />
			</v-flex>
			<div class="top-title">
				<h2>{{ tenant.appName || appname }}</h2>
				<h3 v-if="!tenant.appName">{{ slogan }}</h3>
			</div>
			<v-flex class="admin-register-container">
				<v-card class="admin-register">
					<p v-if="preRegionName">{{ preRegionName }}</p>
					<h2 class="primary--text">企业注册</h2>
					<v-form v-model="form.valid" style="margin-top: 10px" ref="form">
						<v-select v-if="provinces" :items="provinces" label="所属省份" v-model="province" item-value="id"
							item-text="name" required></v-select>
						<v-select v-if="cities" :items="cities" label="所属城市" v-model="city" item-value="id"
							item-text="name" required></v-select>
						<v-select v-if="regions" :items="regions" label="所属区县" v-model="form.region" item-value="id"
							item-text="name" required></v-select>
						<v-text-field validate-on-blur label="企业全称" v-model="form.ename" :rules="rules.required"
							required></v-text-field>
						<v-text-field validate-on-blur label="负责人姓名" v-model="form.name" :rules="rules.required"
							required></v-text-field>
						<v-text-field validate-on-blur label="负责人手机号" v-model="form.mobile" :rules="rules.mobile"
							ref="mobile" required></v-text-field>
						<v-layout row align-center>
							<v-text-field validate-on-blur label="短信验证码" v-model="form.mcode" :rules="rules.required"
								required></v-text-field>

							<v-btn outline color="primary" small disabled style="margin-right: 0;" v-if="countDown">
								{{ countDown }}
							</v-btn>
							<v-btn outline color="primary" small @click.stop="getCaptcha" style="margin-right: 0;"
								v-else>
								获取短信验证码
							</v-btn>
						</v-layout>
						<v-text-field label="设置密码" required validate-on-blur v-model="form.password"
							:rules="rules.required" :append-icon="passwordShow ? 'visibility' : 'visibility_off'"
							:type="passwordShow ? 'text' : 'password'" @click:append="passwordShow = !passwordShow">
						</v-text-field>
						<v-text-field label="再次输入密码确认" required validate-on-blur v-model="form.passwordConf"
							:rules="rules.passwordConf"
							:append-icon="passwordConfShow ? 'visibility' : 'visibility_off'"
							:type="passwordConfShow ? 'text' : 'password'"
							@click:append="passwordConfShow = !passwordConfShow"></v-text-field>
						<v-btn block color="primary" @click.prevent="submit">注册</v-btn>
					</v-form>
				</v-card>
			</v-flex>
			<v-flex class="copyright">
				<p class="white--text my-0 mt-3 text-xs-center">&copy;2025 {{ tenant.copyrights || company }}</p>
				<p class="white--text my-0 mt-3 text-xs-center"><a href="https://beian.miit.gov.cn/" target="_blank"
						style="color: #fff; text-decoration: none">{{ tenant.icp || icp }}</a><span class="ver">最近更新: {{
			version }}</span></p>
			</v-flex>
		</v-layout>

		<v-dialog v-model="dialog" persistent max-width="400">
			<v-card class="admin-register-dialog">
				<v-container grid-list-md py-0 px-4>
					<p class="dialog-title">请输入图片验证码</p>
					<v-layout wrap>
						<v-text-field validate-on-blur label="图片验证码" required v-model="captcha"
							@keyup.enter="enterCaptcha">
							<img class="captcha" :src="captchaUrl" slot="append" @click.stop="refreshCaptchaUrl" />
						</v-text-field>
					</v-layout>
				</v-container>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" outline block @click="dialog = false">取消</v-btn>
					<v-btn color="primary" block @click="enterCaptcha">确定</v-btn>
					<v-spacer></v-spacer>
				</v-card-actions>
			</v-card>
		</v-dialog>


		<v-dialog v-model="registerSuccess" persistent max-width="290">
			<v-card>
				<div class="register-success-dialog-title">注册成功！</div>
				<v-card-text>您已注册成功企业账户，请点击“确定”后输入手机号、密码登录。</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" block @click="backLogin">确定</v-btn>
					<v-spacer></v-spacer>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
import CanvasNest from "canvas-nest.js";

let cn;
export default {
	name: "admin-register",
	data() {
		return {
			captchaUrl: this.$const.baseUrl + "/p/captcha.png?" + Date.now(),
			appname: this.$const.appName,
			slogan: this.$const.slogan,
			company: this.$const.company,
			icp: this.$const.icp,
			version: this.$const.version,
			passwordShow: false,
			passwordConfShow: false,
			dialog: false,
			registerSuccess: false,
			captcha: "",
			countDown: 0,
			interval: 0,
			form: {
				valid: false,
				ename: "",
				name: "",
				mobile: "",
				mcode: "",
				password: "",
				passwordConf: "",
				region: ""
			},
			rules: {
				mobile: [
					v => !!v || "手机号必须填写",
					v => v.length == 11 || "手机号不正确"
				],
				required: [v => !!v || "必须填写"],
				passwordConf: [
					v => !!v || "必须填写",
					v => v == this.form.password || "两次密码不一致",
				],
				region: [v => !!v || "必需选择"]
			},
			provinces: null,
			cities: null,
			regions: null,
			province: null,
			city: null,
			preRegionName: null
		};
	},
	watch: {
		province() {
			let self = this;
			if (self.province) {
				self.loc(self.province);
			}
		},
		city() {
			let self = this;
			if (self.city) {
				self.loc(self.city);
			}
		}
	},
	computed: {
		tenant() {
			return this.$store.state.tenant;
		},
		alert() {
			return this.$store.state.alert;
		}
	},
	mounted() {
		cn = new CanvasNest(document.querySelector("body"), {
			color: "255,255,255",
			pointColor: "255,255,255",
			count: 88,
			opacity: 0.8,
			zIndex: 0
		});
	},
	beforeDestroy() {
		cn.destroy();
		clearInterval(this.interval)
	},
	methods: {
		getCaptcha() {
			if (!this.$refs.mobile.validate()) {
				this.$refs.mobile.validate(true)
				return
			}
			this.refreshCaptchaUrl()
			this.dialog = true
		},
		refreshCaptchaUrl() {
			this.captchaUrl = this.$const.baseUrl + "/p/captcha.png?" + Date.now();
			this.captcha = "";
		},
		enterCaptcha() {
			if (this.captcha) {
				this.$axios.get(`/p/sm/send/1`, {
					params: {
						mobile: this.form.mobile,
						captcha: this.captcha
					}
				})
					.then(r => {
						if (r.data && r.data.status == 'ok') {
							this.countDown = 60
							this.interval = setInterval(() => {
								if (this.countDown <= 0) {
									this.countDown = 0
									clearInterval(this.interval)
								} else {
									this.countDown = this.countDown - 1
								}
							}, 1000)
							this.dialog = false
						} else {
							this.$store.commit("alert", {
								show: true,
								type: "error",
								msg: r.data.message || '提交验证码错误',
								timeout: 2000
							});
							this.refreshCaptchaUrl()
						}
					})
			} else {
				this.$store.commit("alert", {
					show: true,
					type: "error",
					msg: "请输入图片中的验证码",
					timeout: 3000
				});
			}
		},
		backLogin() {
			this.$router.replace('/login')
		},
		submit() {
			let { tid, oid } = this.$query();
			if (!tid) {
				this.$store.commit("alert", {
					show: true,
					type: "error",
					msg: "没有租户信息",
					timeout: 3000
				});
				return
			}
			if (this.$refs.form.validate()) {
				let data = this.form
				if (oid) {
					data.oid = oid
				}
				this.$axios.post(`/p/org/reg/${tid}`, this.$qs.stringify(data))
					.then(r => {
						if (r.data && r.data.status == 'ok') {
							this.registerSuccess = true
						} else {
							this.$store.commit("alert", {
								show: true,
								type: "error",
								msg: r.data.message || "注册失败",
								timeout: 3000
							});
						}
					})
			}
		},
		loc(p) {
			//如果region为null，那就是选择省、市、县
			//如果reigon不为null，后两位市00，选择市、县，后两位不是0选择县。
			let self = this;
			self.$axios.get(`/p/lbs/district/${p || 0}`).then(r => {
				r = r.data.message;
				if (p) {
					if (p.lastIndexOf('0000') == p.length - 4) {
						self.regions = null;
						self.city = null;
						self.form.region = '';
						self.cities = r;
					} else {
						self.regions = r;
						self.form.region = '';
					}
				} else {
					self.cities = null;
					self.regions = null;
					self.province = null;
					self.city = null;
					self.form.region = '';
					self.provinces = r;
				}

			});

		}
	},
	created() {
		let self = this, query = self.$query(), region = null;
		if (query) {
			region = query.region;
		}

		if (region) {
			self.$axios.get(`/p/lbs/get/${region}`).then(r => {
				if (r.data.status == 'ok' || r.data.message) {
					self.preRegionName = r.data.message.fullname;
					self.loc(region);
				}
			})
		} else {
			self.loc(region);
		}
	}
};
</script>

<style scoped>
.admin-register-bg {
	background: var(--v-primary-base) url("../assets/login.png") center bottom no-repeat;
	position: relative;
}

.admin-register-bg .top-logo {
	flex-grow: 0;
	margin-top: 36px;
	display: inline-flex;
}

.admin-register-bg .top-logo img {
	width: auto;
	height: 30px;
}

.admin-register-bg .admin-register-container {
	flex-grow: 0;
}

.admin-register-bg .top-title h2 {
	text-align: center;
	color: white;
	font-size: 24px;
	margin: 8px 0;
}

.admin-register-bg .top-title h3 {
	text-align: center;
	color: white;
	font-size: 16px;
	font-weight: normal;
	margin: 8px 0;
}

.admin-register-bg .copyright {
	flex-grow: 0;
}

.admin-register {
	max-width: 450px;
	text-align: center;
	padding: 40px 65px;
	margin-top: 40px;
}

.admin-register img.logo {
	max-width: 100px;
}

.admin-register h2 {
	font-size: 24px;
	line-height: 1.5;
}

.admin-register h3 {
	font-size: 16px;
	font-weight: normal;
	margin-top: 20px;
}

.admin-register form {
	margin-top: 40px;
}

.admin-register form .remember {
	margin-top: 0;
}

.admin-register-dialog img.captcha {
	width: 120px;
	cursor: pointer;
}

.admin-register-dialog .dialog-title {
	padding-top: 16px;
	margin-bottom: 0;
	font-size: 18px;
}

.register-success-dialog-title {
	padding: 16px;
	padding-bottom: 0;
	margin-bottom: 0;
	font-size: 18px;
}

@media screen and (max-height: 800px) {
	.admin-register-container .top-logo {
		margin-top: 10px;
	}

	.admin-register {
		margin-top: 20px;
	}

	.admin-register-container {
		background-size: 50%;
	}
}

.ver {
	padding: 8px;
}
</style>
